module.exports = __webpack_public_path__ + "img/art2.0d2da4a2.png";